/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddProjectPenaltyDetailsTemplateToPenaltyCommandResult } from '../../models/add-project-penalty-details-template-to-penalty-command-result';
import { CreatePenaltyDetailsVm } from '../../models/create-penalty-details-vm';

export interface ApiProjectPenaltiesDetailsTemplateAddProjectPenaltyDetailsTemplateToPenaltyPost$Plain$Params {
      body?: {
'Id'?: string;
'PenaltyDetails'?: Array<CreatePenaltyDetailsVm>;
}
}

export function apiProjectPenaltiesDetailsTemplateAddProjectPenaltyDetailsTemplateToPenaltyPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesDetailsTemplateAddProjectPenaltyDetailsTemplateToPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddProjectPenaltyDetailsTemplateToPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesDetailsTemplateAddProjectPenaltyDetailsTemplateToPenaltyPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddProjectPenaltyDetailsTemplateToPenaltyCommandResult>;
    })
  );
}

apiProjectPenaltiesDetailsTemplateAddProjectPenaltyDetailsTemplateToPenaltyPost$Plain.PATH = '/api/ProjectPenaltiesDetailsTemplate/AddProjectPenaltyDetailsTemplateToPenalty';
